import AboutUs from "../../components/molecules/aboutUs";
import Footer from "../../components/molecules/footer";
import Header from "../../components/molecules/header";
import HowWeWork from "../../components/molecules/howWeWork";

const About = () => {
  return (
    <>
      <Header />
      <main>
        <AboutUs />
        <HowWeWork />
      </main>
      <Footer />
    </>
  );
};

export default About;
